var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
        settingItem: true,
        enabled: _vm.status,
    },attrs:{"aria-checked":_vm.status ? 'true' : 'false',"role":"checkbox"},on:{"click":_vm.toggle,"keypress":_vm.moveSet}},[_vm._v("\n    "+_vm._s(_vm.settingName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }